import AssessmentTrackMixin from '@/apps/assessment/mixins/assessment-track-mixin'
import RouterMixin from '@/apps/assessment/mixins/router-mixin'
import { getBaseInfo, getExamInfo } from '@/apps/assessment/model/api'
import { AssessmentAllowSubjects } from '@/common/allow-list'
import SmallBtnSkeleton from '@/components/common/small-btn-skeleton'
import { Component, Mixins, Prop, Provide, Vue, Watch } from 'vue-property-decorator'
import { applyRevise, examDelete, getExamDelete, getExamList, getExamStatus, getOnlineList } from '../model/api'
import { COlUMNS, PUB_COlUMNS, PUBLISH_LIST } from '../model/list'

const TAG_SETTING = [
  {
    text: '进行中',
    bg: '#F0F9ED',
    font: '#6AC54D'
  },
  {
    text: '已结束',
    bg: '#F3F5F9',
    font: '#4D5271'
  },
  {
    text: '未上线',
    bg: '#E7E7FF',
    font: '#5D5BFF'
  },
  {
    text: '未发布',
    bg: '#FFF1EB',
    font: '#6AC54D'
  },
  {
    text: '未开始',
    bg: '#E7E7FF',
    font: '#5D5BFF'
  },
  {
    text: '原始数据',
    bg: '#FFF1EB',
    font: '#6AC54D',
    nick: '未发布'
  },
  {
    text: '',
    bg: '#F0F9ED',
    font: '6AC54D'
  }
]

const proSource = '校级测评列表'
const examType = 'unify'
const PUBLISH_ALREADY = { label: '已发布', value: 2 }
const UNPUBLISH = { label: '未发布', value: 1 }

@Component({ components: { SmallBtnSkeleton } })
export default class AssessmentList extends Mixins(AssessmentTrackMixin, RouterMixin) {
  private columns = COlUMNS
  private columnPub = PUB_COlUMNS
  private datasource = []
  private unPubData = []
  private subject: any = {}
  private statusList = []
  private publishList = PUBLISH_LIST
  private publishMethod: any = this.pb == '1' ? UNPUBLISH : PUBLISH_ALREADY
  private selectedStatus = []
  private selectedClazz = []
  private pagination = {
    current: 1,
    total: 0
  }
  private prefix =
    process.env && process.env.VUE_APP_PUBLIC_MAIN_URL
      ? process.env.VUE_APP_PUBLIC_MAIN_URL
      : 'http://www.test.17zuoye.net'
  private subjectList = this.supportSubjects
  private optionsLoading = true
  private visible = false
  private examId =  ''

  private get supportSubjects() {
    let supportSubjects = this.$store.state.supportSubjects
    if (supportSubjects && supportSubjects.length > 0) {
      return [...supportSubjects]
    } else {
      return []
    }
  }

  private get defaultSubject() {
    return this.$route.query.subject
  }
  // publish-method
  private get pb() {
    return this.$route.query.pb
  }
  // 获取班级测评列表
  private get clazzLevelList() {
    const subjectLeaderList = this.supportSubjects
    if (this.subject && this.subject.nick) {
      const CSubject = subjectLeaderList.find((m) => {
        return m.nick === this.subject.nick
      })
      return CSubject && CSubject.clazzLevels
    }
    return []
  }

  @Watch('supportSubjects', { immediate: true, deep: true })
  public onSupportSubjects(val) {
    if (this.defaultSubject) {
      this.subject = this.supportSubjects.find((n) => n.nick === this.defaultSubject)
    } else {
      if (val && val.length > 0) {
        this.subject = val[0]
      }
    }
    this.getBaseInfo()
  }

  public mounted() {
    this.columns.map(item => {
      item.title = ['examTypeName', 'examStartTime'].includes(item.dataIndex) &&
        this.$store.state.user_info && this.$store.state.user_info.regions && this.$store.state.user_info.regions.length &&
        this.$store.state.user_info.regions[2].code == 310112 ? item.title.replace('测评', '练习') : item.title
    })
    this.columnPub.forEach(item => {
      item.title = ['examTypeName', 'examStartTime'].includes(item.dataIndex) &&
        this.$store.state.user_info && this.$store.state.user_info.regions && this.$store.state.user_info.regions.length &&
        this.$store.state.user_info.regions[2].code == 310112 ? item.title.replace('测评', '练习') : item.title
    })
  }

  public unPubEdit(id) {
    this.$router.push({
      path: '/assessment/publish',
      query: {
        subject: this.subject.nick,
        subject_id: this.subject.value,
        tid: id,
        f: encodeURIComponent(proSource)
      }
    })
  }
  // 未发布 - 删除
  public unPubDeleteExam(id) {
    this.$confirm({
      title: '确定删除？',
      onOk: async () => {
        this.trackDelete({ Assessment_id: id })
        await this.getExamStatus(id, this.getExamDelete, this.examDelete)
        setTimeout(() => {
          this.getExamList(this.pagination.current)
        }, 500)
      },
      onCancel: () => {}
    })
  }
  public unPublic(id) {}
  public onStatusChange() {
    this.getOnlineList(1)
  }
  public onClazzChange() {
    if (this.publishMethod.value === 1) {
      this.getExamList(1)
    } else {
      this.getOnlineList(1)
    }
  }
  public tagColor(text) {
    if (text) {
      const reuslt = TAG_SETTING.find((item) => item.text === text)
      return reuslt
    } else {
      return TAG_SETTING[0]
    }
  }
  // 获取基础信息
  public async getBaseInfo() {
    try {
      this.optionsLoading = true
      const data: any = await getBaseInfo({})
      if (data.success) {
        this.statusList = data.statusList
        if (this.publishMethod.value === 1) {
          this.getExamList(1)
        } else {
          this.getOnlineList(1)
        }
      }
    } catch (e) {
      console.log(e)
    } finally {
      this.optionsLoading = false
    }
  }
  // 获取试卷列表
  public async getExamList(page) {
    this.pagination.current = page
    try {
      const param = {
        subjectId: Number(this.subject.value),
        clazzLevels: this.selectedClazz,
        page: this.pagination.current,
        examType
      }
      const data: any = await getExamList(param)
      if (data.success) {
        this.pagination.total = data.data.total
        this.unPubData = data.data.records
      } else {
        this.pagination.total = 0
        this.unPubData = []
      }
    } catch (e) {
      console.log(e)
    }
  }
  // 获取试卷列表已发布
  public async getOnlineList(page) {
    if (!(this.subject && this.subject.nick)) return
    this.pagination.current = page
    const param = {
      clazzLevels: this.selectedClazz.join(','),
      status: this.selectedStatus.join(','),
      currentPage: page,
      subject: this.subject && this.subject.nick,
      _: new Date().getTime()
    }
    try {
      const data: any = await getOnlineList(param)
      if (data.success) {
        this.datasource = data.page.content
        this.pagination.total = data.page.totalElements
      } else {
        this.datasource = []
        this.pagination.total = 0
      }
    } catch (e) {
      console.log(e)
    }
  }
  // 删除测评
  public async getExamDelete(id) {
    const data: any = await getExamDelete({ id })
  }
  public async examDelete(examId) {
    const data: any = await examDelete({ examId })
  }

  public async applyRevise(examId){
    const data: any = await applyRevise({ examId })
  }
  public async onDeleteExam(examId) {
    const data: any = await getExamInfo({ examId })
    if(data.data.newExamStatus == 'DRAFT'){
      this.examId = examId
      this.visible = true
    }else{
      this.$confirm({
        title: '确定删除？',
        onOk: () => {
          this.trackDelete({ Assessment_id: examId })
          this.examDelete(examId)
          this.getOnlineList(this.pagination.current)
        },
        onCancel: () => {}
      })
    }
  }
  // 申请修改
  public handleRevise(){
    this.applyRevise(this.examId)
    this.visible = false
    const h = this.$createElement
    this.$success({
      title:'',
      content: h('div', {}, [
        h('p', '申请成功'),
        h('p', '请稍后，工作人员将及时与您取得联系'),
      ]),
      okText: '确定'
    })
    window['sensors'].track('TIKU_Assessment_edit_request', { buttonName: '申请修改' })
  }

  public onEditExam(record) {
    this.$router.push({
      path: '/assessment/publish',
      query: { exam: record.examId, subject: this.subject.nick, f: encodeURIComponent(proSource) }
    })
  }
  // 获取测评状态
  public async getExamStatus(id, method, method2) {
    try {
      const data: any = await getExamStatus({
        id
      })
      if (data.success) {
        if (data.data.status === 'RAW') {
          method(id)
        } else {
          method2(data.data.examId)
        }
      }
    } catch (e) {
      console.log(e)
    }
  }
  // 选择学科
  public selectSubject(itm) {
    this.subject = itm
    if (this.publishMethod.value === 1) {
      this.getExamList(1)
    } else {
      this.getOnlineList(1)
    }
  }
  //
  public selectPublishMethod(itm) {
    this.publishMethod = itm
    if (itm.value === 1) {
      this.getExamList(1)
    } else {
      this.getOnlineList(1)
    }
  }
  public findProgress(record) {
    window.open('/assessment/info?record=' + encodeURIComponent(JSON.stringify(record)))
  }
  // 表格分页切换
  public onTablechange(pagination) {
    const pager = { ...this.pagination }
    pager.current = pagination.current
    this.pagination = pager
    if (this.publishMethod.value === 1) {
      this.getExamList(pagination.current)
    } else {
      this.getOnlineList(pagination.current)
    }
  }
  // 点击下载成绩单
  public onclickOrder(record) {
    this.trackDownloadOrder({
      Assessment_subject: this.subject.label,
      Grade: record.clazzLevelName
    })
  }
}
